export default __webpack_public_path__ + "static/media/Snd4.e13e87df.mp3";